// extracted by mini-css-extract-plugin
module.exports = {"counter":"WordCounter_counter__a8XEG","warning":"WordCounter_warning__2t_5F"};